import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { UserService } from "../../services";
import { asQuery } from "../../services/common";
import { AD_STALE } from "./shared";

// Sellers directory (public). Changes rarely, so the 5-min global default
// staleTime is fine; keepPreviousData avoids skeleton flicker while the
// keyword search refetches.
export function useSellers(params: any) {
  return useQuery({
    queryKey: ["users", "sellers", params],
    queryFn: () => asQuery<any[]>(UserService.getSellers(params)),
    placeholderData: keepPreviousData,
  });
}

// Top sellers for the home "featured artists" row (global-default staleTime).
export function useTopSellers(location?: any) {
  return useQuery({
    queryKey: ["users", "top-sellers", location],
    queryFn: () => asQuery<any[]>(UserService.getTopSellers({ location })),
  });
}

// A seller's public profile + aggregate rating.
export function useSellerProfile(userId?: string, location?: any) {
  return useQuery({
    queryKey: ["users", "public", userId, location],
    queryFn: () =>
      asQuery<any>(UserService.getAllPublicInfo({ userId, location })),
    enabled: !!userId,
    staleTime: AD_STALE,
  });
}
